import { DatePipe } from '@angular/common';
import { Component, Inject, inject, signal } from '@angular/core';
import { Router } from '@angular/router';

import { StorageService } from '@app/core/services/storage.service';
import { ButtonComponent } from '@app/core/ui/components/button';
import { ModalService } from '@app/core/ui/components/modal';
import { MODAL_DATA } from '@app/core/ui/components/modal/modal.component';
import { StorageEnum } from '@app/shared/enums/storage.enum';

export interface LastDaysReminderModel {
  limitDate: string;
  cycleId: number;
}

export type StorageLastDaysReminder = Record<PropertyKey, number>;

@Component({
  selector: 'mw-last-days-reminder-modal',
  imports: [ButtonComponent, DatePipe],
  templateUrl: './last-days-reminder-modal.component.html',
  styleUrl: './last-days-reminder-modal.component.scss'
})
export class LastDaysReminderModalComponent {
  private readonly modal = inject(ModalService);
  private readonly storage = inject(StorageService);
  private router = inject(Router);

  readonly limitDate = signal<string>('');
  private readonly cycleId: number | null = null;

  constructor(@Inject(MODAL_DATA) private data: LastDaysReminderModel) {
    this.limitDate.set(this.data.limitDate);
    this.cycleId = this.data.cycleId;
  }

  handleCloseModal() {
    this.modal.close();
  }

  handleSaveAndRedirectButton() {
    if (!this.cycleId) {
      console.warn('There was an error getting cycleId property');
      this.router.navigate(['/turmas']).then(() => this.modal.close());
      return;
    }
    const timestamp = new Date().getTime();
    const currentLastDaysReminderStorage =
      this.storage.get<StorageLastDaysReminder>(
        StorageEnum.LastDaysReminder,
        'session'
      );

    this.storage.save(
      StorageEnum.LastDaysReminder,

      {
        ...(currentLastDaysReminderStorage || {}),
        [this.cycleId]: timestamp
      },
      'session'
    );
    this.router.navigate(['/turmas']).then(() => this.modal.close());
  }
}
